import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { event: String }

  connect() {
    const frameId = this.element.closest("turbo-frame")?.id || this.eventValue
    const containerId = `cal-inline-${frameId}`
    this.element.id = containerId

    if (!window.Cal) {
      ;(function (C, A, L) { // eslint-disable-line
        let p = function (a, ar) { a.q.push(ar) }
        let d = C.document
        C.Cal = C.Cal || function () {
          let cal = C.Cal, ar = arguments
          if (!cal.loaded) {
            cal.ns = {}; cal.q = cal.q || []
            d.head.appendChild(d.createElement("script")).src = A
            cal.loaded = true
          }
          if (ar[0] === L) {
            const api = function () { p(api, arguments) }
            const ns = ar[1]; api.q = api.q || []
            if (typeof ns === "string") { cal.ns[ns] = cal.ns[ns] || api; p(cal.ns[ns], ar); p(cal, [L, ns, ar[2]]) }
            else p(cal, ar)
            return
          }
          p(cal, ar)
        }
      })(window, "https://www.cal.eu/embed/embed.js", "init") // eslint-disable-line
      Cal("init", { origin: "https://www.cal.eu" })
    }

    Cal("inline", {
      elementOrSelector: this.element,
      calLink: `lauzaloistl/${this.eventValue}`,
    })

    Cal("ui", {
      cssVarsPerTheme: {
        light: {
          "cal-bg": "#f4ede1",
          "cal-bg-subtle": "#f4ede1",
          "cal-bg-muted": "#f4ede1",
          "cal-border": "#C5BAA8",
          "cal-border-subtle": "#C5BAA8",
          "cal-border-emphasis": "#3D5A3D",
          "cal-border-booker": "#C5BAA8",
        },
      },
    })

  }
}
